import { useEffect, useRef } from "react";
import { signal, useSignal } from "@preact/signals-react";

import FormMessage from "componentsv2/form/FormMessage";
import FormHeader from "componentsv2/form/FormHeader";
import FormToolbar from "componentsv2/form/FormToolbar";
import TrytonForm from "componentsv2/form/TrytonForm";
import FooterForm from "componentsv2/form/FooterForm";
import ModalMsg from "componentsv2/modal/ModalMsg";
import {
  MessageContainer,
  useMessage,
} from "componentsv2/experimental/Message";
import actionButton from "storev2/actionButton";
import { useStore, insertRecord } from "storev2/formStore";
import { cn } from "tools/ui";
const modalMsg = signal(null);

/**
 * create component Form
 * @param {Object} props
 * @param {Array} props.layout
 * @param {Function} props.modal
 * @returns
 */
function BoardForm(props) {
  const {
    storeId,
    layout,
    onClose,
    handleView,
    parentRec,
    title,
    view,
    refetch,
    style,
    closeOnChangeView,
  } = props;
  const model = layout.model;
  const openModal = useSignal(null);
  const message = useSignal(null);
  const mustReload = useSignal(false);
  const reloadSig = useSignal(0);
  const { messages, warning, hide, clear } = useMessage();
  const prevAlertShow = useRef(false);

  useEffect(() => {
    const msg = layout.alertMsg?.value;
    if (msg?.show && !prevAlertShow.current) {
      warning(msg.text);
    }
    prevAlertShow.current = !!msg?.show;
  }, [layout.alertMsg?.value?.show, layout.alertMsg?.value?.text]);

  useEffect(() => {
    clear();
    return () => clear();
  }, []);

  async function handleButton(btnName, method) {
    console.log("handleButton why ?", btnName, method);
    const { findRecord, saveForm, reload } = useStore.getState();
    // FIXME
    const record = findRecord(storeId);
    mustReload.value = false;
    let button = layout.fields[btnName];
    if (props.handleButton && !button?.button_method) {
      // FIXME
      const record = {};
      props.handleButton(btnName, record);
    } else if (button) {
      if (method) {
        button = method;
      }
      const res = await actionButton({
        button,
        model,
        layout,
        record,
        storeId,
        saveForm,
      });
      if (record.active.id > 0) {
        const _rec = await insertRecord(record.active.id, model, layout);
      }
      let msgCtx = null;
      if (res.error) {
        msgCtx = {
          type: res.error.type,
          msg: res.error.error,
        };
      } else if (res.msg || button.onSuccessMsg) {
        msgCtx = {
          type: "success",
          msg: button.onSuccessMsg || res.msg,
          // onClose: ,
          // mustReload: true,
        };
        mustReload.value = true;
      }

      handleInfo(msgCtx);
      if (mustReload.value) {
        await reload(storeId);
        reloadSig.value += 1;
      }
    }
  }

  function onCloseModalMsg(button, resetForm) {
    message.value = null;
    openModal.value = false;
  }

  async function onYesModalMsg() {
    if (layout.preSave) {
      handleButton(layout.preSave);
    } else {
      const res = await onSave("save", "modal");
      console.log("Debe recargar si o no?", mustReload.value);
      if (res) {
        if (refetch) await refetch();
        if (onClose) onClose();
        handleView("return");
      }
    }
  }

  // async function reloadForm() {
  //   const { reload } = useStore.getState();
  //   await reload(parentRec.storeId.value);
  //   reloadSig.value += 1;
  // }

  async function onReturnModalMsg() {
    onCloseModalMsg({ resetForm: true }, true);
    if (mustReload.value && refetch) await refetch();
    handleView("return");
  }

  function handleInfo(res, viewMsg) {
    if (!res) return;
    const { msg, error, type } = res;
    // viewMsg: is normally a place where we show the message: modal/board
    const msgType = "error";
    if (viewMsg === "modal") {
      if (msg === "ok") return true;
      let msgModal = msg;
      if (!msg && error) {
        // TypeError is for network error or similars
        msgModal = error instanceof TypeError ? error.message : error.error;
      }
      modalMsg.value = {
        msg: msgModal,
        type: msgType,
        buttons: { close: onCloseModalMsg },
      };
      openModal.value = true;
    } else {
      message.value = res;
      const timeoutId = setTimeout(() => {
        message.value = null;
      }, 3000);
    }
  }

  async function onSave(action, viewMsg) {
    const { findRecord, saveForm, deleteRecord, updateParentForm, reload } =
      useStore.getState();

    const childRecord = findRecord(storeId);
    const record = childRecord?.active;
    if (parentRec?.record.id < 0) {
      updateParentForm(childRecord, parentRec);
      onClose();
      return;
    }

    console.log("record ....", record);
    if (
      ["create", "delete", "accept", "save"].includes(action) &&
      layout.triggerCreate
    ) {
      console.log("parentRec......", parentRec);
      let resTrigger = layout.triggerCreate(parentRec, record, onClose);
      console.log("resTrigger......", resTrigger);
      return resTrigger;
    }

    // actionType: 'create', 'delete', 'write', 'accept' (write/create)
    // records: is used only for 'records' to delete / add / create
    if (action === "delete" && record.id > 0) {
      const res = await deleteRecord(model, record.id);
      if (!res?.error && onClose) {
        // if (view === "modal" && storeId) {
        //   reloadTable(storeId);
        // }
        mustReload.value = true;
        onClose(mustReload);
      }
      return;
    }

    const res = await saveForm(storeId);
    if (layout.afterSave) await layout.afterSave(record?.id);
    if (res && res.type === "info") {
      if (viewMsg === "modal" && ["create", "accept"].includes(action)) {
        mustReload.value = true;
        if (refetch) await refetch();
        onClose(mustReload);
        console.log("Show here 1 NOT RELOAD?");
        return;
      }
      console.log("Show here yes RELOAD?");
      if (refetch) await refetch();
      await reload(storeId);
      reloadSig.value += 1;
    } else if (!res) {
      console.log("Show here 2 NOT RELOAD?");
      return;
    }

    console.log("Show here 2", res);
    const result = handleInfo(res, viewMsg);
    return result;
  }

  function onChangeView(action) {
    const { findRecord } = useStore.getState();
    if (action === "return") {
      message.value = null;
      const record = findRecord(storeId);
      const store_ = record.store;
      if (record && store_ && Object.values(store_).length > 1) {
        modalMsg.value = {
          msg: "board.want_to_save_data",
          type: "ask",
          buttons: [
            {
              label: "button.no",
              name: "no",
              onClick: onReturnModalMsg,
              color: "black",
            },
            {
              label: "button.yes",
              name: "yes",
              onClick: onYesModalMsg,
            },
          ],
        };
        openModal.value = true;
        return;
      }
    }
    handleView(action);
  }

  function handleCloseMessage() {
    message.value = null;
  }

  // let heightContent = "max-h-screen";
  // let heightContent = "h-[1100px]";

  // console.log("Render en BoardForm ", reloadSig.value);
  return (
    <div id="board-form" className="flex flex-col h-full">
      {title && <FormHeader layout={layout} />}
      <FormMessage message={message} handleClose={handleCloseMessage} />
      <div id="form-header" className="flex">
        {layout.customToolbar && (
          // FIXME use storeId not recordId
          <layout.customToolbar storeId={storeId} />
        )}
        {layout.form_toolbar !== false && (
          <FormToolbar
            view={view}
            layout={layout}
            storeId={storeId}
            onChangeView={onChangeView}
            onSave={onSave}
            onClose={onClose}
          />
        )}
      </div>
      <div
        id="form-content"
        className={cn("grow min-h-0 overflow-y-auto", style)}
      >
        <TrytonForm
          storeId={storeId}
          layout={layout}
          handleButton={handleButton}
          parentRec={parentRec}
          reloadSig={reloadSig.value}
          // reload={reloadForm}
        />
      </div>
      <MessageContainer
        messages={messages}
        onMessageClose={hide}
        position="top-center"
      />
      {layout.display !== "board" && (
        <FooterForm
          id="form-footer"
          layout={layout}
          storeId={storeId}
          onChangeView={onChangeView}
          onSave={onSave}
          onClose={onClose}
          closeOnChangeView={closeOnChangeView}
        />
      )}
      <ModalMsg id="form-modal-msg" attrs={modalMsg} openModal={openModal} />
    </div>
  );
}

export default BoardForm;
